module.exports = __webpack_public_path__ + "img/preview.f9731876.png";